import {
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
  BorderStyle,
  HeadingLevel,
  ShadingType,
  VerticalAlign,
  AlignmentType,
} from "docx";

export function ModelWorldProgramList(tableContent) {
  const createCell = (text, options = {}) => {
    return new TableCell({
      width: { size: options.width || 1000, type: WidthType.DXA },
      margins: { top: 100, bottom: 100, left: 100, right: 100 },
      borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "d9d9d9" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "d9d9d9" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "d9d9d9" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "d9d9d9" },
      },
      shading: options.shadingColor
        ? { fill: options.shadingColor }
        : undefined,
      children: [
        new Paragraph({
          children: [
            new TextRun({
              text: text,
              bold: options.bold || false,
              color: options.color || "000000",
              size: options.fontSize ? options.fontSize * 2 : 22,
            }),
          ],
          alignment: options.alignment || "left",
        }),
      ],
    });
  };

  const docSections = [];

  Object.entries(tableContent).forEach(([qarku, programet]) => {
    // Shtojmë titullin e qarkut si Paragraph
    docSections.push(
      new Paragraph({
        heading: HeadingLevel.HEADING_2,
        spacing: { after: 300, before: 300 },
        alignment: AlignmentType.CENTER, // qendër horizontale
        shading: {
          type: ShadingType.CLEAR,
          fill: "F44336", // sfondi i kuq
        },
        children: [
          new TextRun({
            text: qarku,
            bold: true,
            color: "FFFFFF",
            size: 28, // madhësia e fontit (14pt, sepse 28/2=14pt)
            // VerticalAlign nuk vendoset tek TextRun për rreshtat e paragrafit, po te TableCell
          }),
        ],
      })
    );
    // Krijojmë headerin e tabelës
    const headerRow = new TableRow({
      children: [
        createCell("", {
          bold: true,
          color: "000000",
          alignment: "center",
          width: 150,
        }),
        createCell("Programi", {
          bold: true,
          color: "000000",
          alignment: "center",
        }),
        createCell("Licenca", {
          bold: true,
          color: "000000",
          alignment: "center",
        }),
        createCell("Rrjeti numerik ku mbartet", {
          bold: true,
          color: "000000",
          alignment: "center",
        }),
        createCell("Mbulesa e sinjalit", {
          bold: true,
          color: "000000",
          alignment: "center",
        }),
      ],
    });

    // Krijojmë rreshtat e të dhënave
    const dataRows = programet.map(
      (p, idx) =>
        new TableRow({
          children: [
            createCell(String(idx + 1), { alignment: "center", width: 150 }),
            createCell(p["Programi"] || ""),
            createCell(p["Licensa"] || ""),
            createCell(p["Rrjeti numerik ku mbartet"] || ""),
            createCell(p["Mbulimi faktik me sinjal"] || ""),
          ],
        })
    );

    // Shtojmë tabelën
    docSections.push(
      new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [headerRow, ...dataRows],
      })
    );
  });

  return docSections;
}
